import React, { forwardRef } from 'react'

import styles from './index.module.css'
import { cn, UtilityClassNames } from '@s4l/utility-css'

interface HamburgerButtonOwnProps {
  isOpen: boolean
  className?: UtilityClassNames
}

export type HamburgerButtonProps = HamburgerButtonOwnProps &
  Omit<React.ComponentPropsWithoutRef<'button'>, keyof HamburgerButtonOwnProps>

const HamburgerButton = forwardRef<HTMLButtonElement, HamburgerButtonProps>(
  function HamburgerButton({ isOpen, className, ...props }, ref) {
    return (
      <button
        type="button"
        data-testid="hamburger-button"
        className={cn(styles.button, className)}
        aria-label="Toggle menu"
        ref={ref}
        {...props}
      >
        <span
          className={cn(styles.bar, 'mb-4', {
            [styles.topBarOpen]: isOpen,
          })}
        />

        <span
          className={cn(styles.bar, 'mb-4', {
            [styles.middleBarOpen]: isOpen,
          })}
        />

        <span
          className={cn(styles.bar, {
            [styles.bottomBarOpen]: isOpen,
          })}
        />
      </button>
    )
  }
)

export default HamburgerButton
